import { bcbs_groupconfigurationsnapshot } from "model/CRM";
import { IAccountsReceivable, IBenefit, ICESNumber, IDepartment, IFeesAndPremiums, IFlexibleFieldSet, IGroupConfigurationData, IGroupNumber, INonStandard, IPlan, IStopLoss } from "model/FlexibleAttributeModel";
import { blankSnapshot } from "model/snapshotTemplate";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

export class EnsurePropertiesAreInitializedTransformer extends BaseJsonTransformer {
    async transformGroupConfiguration(json: IGroupConfigurationData, snapshot: bcbs_groupconfigurationsnapshot): Promise<void> {

        const blank = blankSnapshot();

        // it's all null
        if (!json)
            throw new Error("The json was null or undefined - cannot process.");

        if ((json as any).visibility)
            delete (json as any).visibility;

        if (!json.grandFathered?.value) {
            json.grandFathered = blank.grandFathered
        }

        // if (!json.showInActives?.value)
        // Sebrina T: showing deactivated ones are no longer required to be saved/loaded
        json.showInActives = {
            type: 'bool',
            value: false
        };

        if (!json.status?.value)
            json.status = blank.status;

        // process root level properties
        if (!json.attributeSets)
            json.attributeSets = [];

        if (!json.benefits)
            json.benefits = [];

        if (!json.claimsARs)
            json.claimsARs = [];

        if (!json.comments)
            json.comments = [];

        if (!json.feesAndPremiums)
            json.feesAndPremiums = [];

        if (!json.fields)
            json.fields = [];

        if (!json.groupStructure)
            json.groupStructure = {
                cesNumbers: [],
                departments: [],
                groupNumbers: []
            };

        if (!json.groupStructure.cesNumbers)
            json.groupStructure.cesNumbers = [];

        if (!json.groupStructure.departments)
            json.groupStructure.departments = [];

        if (!json.groupStructure.groupNumbers)
            json.groupStructure.groupNumbers = [];

        if (!json.nonStandards)
            json.nonStandards = [];

        if (!json.nonStandardTemplates)
            json.nonStandardTemplates = [];

        if (!json.plans)
            json.plans = [];

        if (!json.stopLoss)
            json.stopLoss = [];

        if (!json.pharmacyORE)
            json.pharmacyORE = [];

        if (!json.revisionTasks)
            json.revisionTasks = [];

        if (!json.isRevision)
            json.isRevision = {
                type: "bool",
                value: false
            };

        if (!json.transformers)
            json.transformers = {};

        if (!json.notifications)
            json.notifications = [];



    }

    async transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {
        this.initializeDeactivationState(attributeSet);

        if (!attributeSet.fields)
            attributeSet.fields = [];
    }

    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        this.initializeDeactivationState(nonStandard);

        if (!nonStandard.fields)
            nonStandard.fields = [];
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        this.initializeDeactivationState(plan);

        if (!plan.fields)
            plan.fields = [];

        if (!plan.attributeSets)
            plan.attributeSets = [];

        if (!plan.nonStandards)
            plan.nonStandards = [];

        if (!plan.benefitRefs)
            plan.benefitRefs = [];
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        this.initializeDeactivationState(benefit);

        if (!benefit.fields)
            benefit.fields = [];

        if (!benefit.attributeSets)
            benefit.attributeSets = [];

        if (!benefit.nonStandards)
            benefit.nonStandards = [];

        if (!benefit.tiers)
            benefit.tiers = [];
    }

    async transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void> {
        this.initializeDeactivationState(accountsReceivable);

        if (!accountsReceivable.fields)
            accountsReceivable.fields = [];

        if (!accountsReceivable.attributeSets)
            accountsReceivable.attributeSets = [];
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        this.initializeDeactivationState(feesAndPremium);

        if (!feesAndPremium.fields)
            feesAndPremium.fields = [];

        if (!feesAndPremium.attributeSets)
            feesAndPremium.attributeSets = [];
    }

    async transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void> {
        this.initializeDeactivationState(stopLoss);

        if (!stopLoss.fields)
            stopLoss.fields = [];

        if (!stopLoss.attributeSets)
            stopLoss.attributeSets = [];
    }

    async transformCESNumber(cesNumber: ICESNumber): Promise<boolean | void> {
        this.initializeDeactivationState(cesNumber);
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        this.initializeDeactivationState(groupNumber);

        if (!groupNumber.fields)
            groupNumber.fields = [];
    }

    async transformDepartment(department: IDepartment): Promise<boolean | void> {
        this.initializeDeactivationState(department);
    }

    private initializeDeactivationState(obj: any) {
        if (!obj.deactivated)
            obj.deactivated = false;
    }
}